import { z } from 'zod';
export var SeatApplicationLogType;
(function (SeatApplicationLogType) {
    SeatApplicationLogType["Submitted"] = "submitted";
    SeatApplicationLogType["StatusChange"] = "status";
    SeatApplicationLogType["Comment"] = "comment";
    SeatApplicationLogType["WorkflowStepChange"] = "step";
})(SeatApplicationLogType || (SeatApplicationLogType = {}));
export const seatApplicationLogCreateSchema = z.object({
    userId: z.number('User ID is required'),
    meetingBodySeatTermApplicationId: z.number('Meeting body seat term application ID is required'),
    seatApplicationWorkflowStepId: z.number().nullish(),
    type: z.enum(SeatApplicationLogType, 'Invalid log type'),
    message: z.string('Message is required'),
});
